import * as storage from '@/utils/storage'
import * as api from '@/api/'

// initial state
const state = {
  user: storage.user.get()
}
// getters
const getters = {
  user: state => state.user,
}

// actions
const actions = {
  login({ dispatch }, data) {
    return api.auth.login(data).then(response => {
      storage.token.set(response.user.api_token)
      dispatch('getUser')
    })
  },
  getUser({ commit }) {
    return api.auth.get().then(response => {
      commit("setUser", response.user)
      storage.user.set(response.user)
      return response.user
    })
  },
  logout({ commit }) {
    commit('setUser', false)
    storage.token.remove()
    storage.user.remove()
  },
}

// mutations
const mutations = {
  setUser(state, user) {
    state.user = user
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
